module.exports = __webpack_public_path__ + "static/media/MentorJinSYoon.6baea69d.jpeg";